// import React, { useContext } from 'react';
// import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
// import { useState, useEffect } from 'react';
// import { Datacontext } from './Context';
// import App from './App';
// // Admin pages 
// import Overview from './pages/Overview';
// import Login from './pages/Login';
// import Test from './pages/Test';
// import Student_List from './pages/Student_List';
// import Meeting from './pages/Meeting';
// import Courses from './pages/Courses';
// import Mentors from './pages/Mentors';
// import Batches from './pages/Batches';
// import Mentor_Students_Dashboard from './pages/Mentor_Students_Dashboard';
// import Admin_Change_password from './pages/Admin_Change_password';
// import Placements from './pages/Placements';
// import Settings from './pages/Settings';
// import Admin_Placement_List from './pages/Admin_Placement_List.jsx';
// import LeaveManagement from './pages/LeaveManagement';
// import Placement_Dashboard from './pages/Placement_Dashboard.jsx';
// // Mentor Pages 
// import Mentor_Overview from './Mentor_section/pages/Mentor_Overview';
// import Change_password from './Mentor_section/pages/Change_password.jsx';
// import Mentor_courses from './Mentor_section/pages/Mentor_courses';
// import Mentor_tests from './Mentor_section/pages/Mentor_tests.jsx';
// import UpdateProfile from './Mentor_section/pages/UpdateProfile';
// import Mentor_Evaluation_Status from './Mentor_section/pages/Mentor_Evaluation_Status.jsx';
// import Mentor_Take_test from './Mentor_section/pages/Mentor_Take_test.jsx';
// import Mentor_See_Results from './Mentor_section/pages/Mentor_See_Results.jsx';
// import ViewTests from './Mentor_section/pages/ViewTests.jsx';
// import ApplyLeave from './Mentor_section/pages/ApplyLeave';
// import Mentor_Meeting from './Mentor_section/pages/Mentor_Meeting.jsx';
// import Mentor_Assignments_creation from './Mentor_section/pages/Mentor_Assignments_creation.jsx';
// import Mentor_Assignment_View from './Mentor_section/pages/Mentor_Assignment_View.jsx';
// import MentorViewQuestions from './Mentor_section/pages/MentorViewQuestions.jsx';
// import Mentor_Assingment_Sub_List from './Mentor_section/pages/Mentor_Assingment_Sub_List.jsx';
// import Mentor_Change_Password from './Mentor_section/pages/Mentor_Change_Password.jsx';
// import Exam_Evaluation from './Mentor_section/pages/Exam_Evaluation.jsx'
// import Mentor_Leave_Management from './Mentor_section/pages/Mentor_Leave_Management.jsx';
// // Student Pages 
// import Student_Overview from './Student_section/Pages/Student_Overview.jsx';
// import Student_courses from './Student_section/Pages/Student_courses.jsx';
// import Student_course_content from './Student_section/Pages/Student_course_content.jsx';
// import Student_course_content_player from './Student_section/Pages/Student_course_content_player.jsx';
// import Student_test from './Student_section/Pages/Student_test.jsx';
// import Student_Update_Profile from './Student_section/Pages/Student_Update_Profile.jsx';
// import Certification from "./Student_section/Pages/Certification.jsx"
// import Student_Meetings from './Student_section/Pages/Student_Meetings.jsx';
// import Students_placements from "../src/Student_section/Pages/Students_Placements.jsx"
// import Self_learning_courses from './Student_section/Pages/Student_Self_Learning_Courses/LandingPage.jsx';
// import Student_Assignment from "../src/Student_section/Pages/Student_Assignment.jsx"
// import Student_change_password from './Student_section/Pages/Student_change_password.jsx';
// import Student_test_details from './Student_section/Pages/Student_test_details.jsx';
// // Placement Pages 
// import Placement_Drives from './Placement_section/Pages/Placement_Droves.jsx';
// import Placement_Selected from './Placement_section/Pages/Placement_Selected.jsx';
// import Applied from './Placement_section/Pages/Applied.jsx';
// import Selected from './Placement_section/Pages/Selected.jsx';
// import JobListNew from './Placement_section/Pages/NewJobList.jsx';
// // Other 
// import PageNotFound from './ErrorPage/PageNotFound';
// import VideoShowPage from './Student_section/Components/ForTheCoursePart/VideoShowPage.jsx';
// import Maintenance from './pages/Maintenance.jsx';
// import DemoPAge from './Student_section/Pages/DemoPAge.jsx';
// import VideoShowPageTesting from './Student_section/Components/VideoPage/VideoShowPageTesting.jsx';
// import MeeingFeedbackForm from './utilities/MeeingFeedbackForm.jsx';
// import Upload_GETStudent_Feedback_download from './pages/Upload_GETStudent_Feedback_download.jsx';
// import JobList from './Placement_section/Pages/JobList.jsx';
// import JobDetails from './pages/JobDetails.jsx';
// import Mentor_Interview_creation from './Mentor_section/pages/Mentor_Interview_creation.jsx';
// import MentorInterviewList from './Mentor_section/pages/MentorInterviewList.jsx';
// import MentorPortfolioTestCreation from './Mentor_section/pages/MentorPortfolioTestCreation.jsx';
// import MentorPortfolioTestList from './Mentor_section/pages/MentorPortfolioTestList.jsx';
// import MockInterviewDetails from './Student_section/Pages/MockInterviewDetails.jsx';
// import PortfolioDetails from './Student_section/Components/Portfolio/PortfolioDetails.jsx';
// import PortfolioTestDetails from './Student_section/Pages/PortfolioTestDetails.jsx';
// import Recorded_link_content_player from './Student_section/Pages/Recorded_link_content_player.jsx';
// import LiveClassRecording_content_player from './Student_section/Pages/LiveClassRecording_content_player.jsx';









// const Router = () => {
//   const { Usertype } = useContext(Datacontext);
//   const [usertype, setUsertype] = useState(localStorage.getItem('userType'));

//   useEffect(() => {
//     if (Usertype) {
//       setUsertype(Usertype);
//       localStorage.setItem('userType', Usertype);
//     }
//   }, [Usertype]);

//   const defaultRoute =
//     usertype === 'Admin' ? (
//       <Route index element={<Overview />} />
//     ) : usertype === 'Mentor' || usertype=="Mentor_Assistant" ? (
//       <Route index element={<Mentor_Overview />} />
//     )
//     : usertype === 'Student' ? (
//       <Route index element={<Student_Overview />} />
//     )
//     : usertype === 'Placement' ? (
//       <Route index element={<Applied/>} />
//       // <Route index element={<Placement_Drives/>} />
//     )
//     : (
//       <Route index element={<Login />} />
//     );

//     // const basename = '/lms'
//   const router = createBrowserRouter(
//     createRoutesFromElements(
//       <Route path='/' element={<App />}>
//         {defaultRoute}

//         {/* Admin  */}
//         {/* <Route path='login' element={<Login />} /> */}
//         <Route path='test' element={<Test />} />
//         <Route path='Student-List' element={<Student_List />} />
//         <Route path='meeting' element={<Meeting />} />
       
//         <Route path='change-password' element={<Change_password />} />
//         <Route path='mentor-courses' element={<Mentor_courses />} />
//         <Route path='mentors' element={<Mentors />}/>
//         <Route path='courses' element={<Courses/>}/>
//         <Route path='batches' element={<Batches/>}/>
//         <Route path='mentor-test' element={<Mentor_tests/>}/>
//         <Route path='member-profile' element={<UpdateProfile/>}/>
//         <Route path='admin-change-password' element ={<Admin_Change_password/>}/>
//         <Route path='placements' element={<Placements/>}/>
//         <Route path='settings' element={<Settings/>}/>
//         <Route path='mentor-apply-leave' element={<ApplyLeave/>}/>
//         <Route path='mentor-meeting' element={<Mentor_Meeting/>}/>
//         <Route path='testing' element={<h1>Bapan</h1>}/>
//         <Route path='leave-management' element={<LeaveManagement />}/>
//         <Route path='admin-placement-list' element={<Admin_Placement_List/>}/>
//         <Route path='placement-dashboard' element={<Placement_Dashboard/>}/>
//         <Route path="/maintenance" element={<Maintenance/>} />
//         <Route path='feedback_upload_delete' element={<Upload_GETStudent_Feedback_download/> }/>
//         <Route path='job-details' element={<JobDetails/> }/>


//         {/* Mentor  */}
//         <Route path='mentor-evaluation-status' element={<Mentor_Evaluation_Status/>} />
//         <Route path='mentor-take-test' element={<Mentor_Take_test/>} />
//         <Route path='mentor-see-results' element={<Mentor_See_Results/>} />
//         <Route path='view-test' element={<ViewTests/>}/>
//         <Route path='mentor-students-dashboard' element={<Mentor_Students_Dashboard/>}/>
//         <Route path='mentor-assignments-creation' element={<Mentor_Assignments_creation/>}/>
//         <Route path='Mentor-Assignment-View' element={<Mentor_Assignment_View/>}/>
//         <Route path='Mentor-view-questions/:id' element={<MentorViewQuestions/>}/>
//         <Route path='Mentor-Submission-List' element={<Mentor_Assingment_Sub_List/>}/>
//         <Route path='Mentor-change-password' element={<Mentor_Change_Password/>}/>
//         <Route path='test_evaluation' element={<Exam_Evaluation/>}/>
//         <Route path='Mentor-Leave-Management' element={<Mentor_Leave_Management/>}/>
//         <Route path='Mock-Interview-Creation' element={<Mentor_Interview_creation/>}/>
//         <Route path='Mock-Interview-ALL' element={<MentorInterviewList/>}/>
//         <Route path='Mentor-portfolio-test-creation' element={<MentorPortfolioTestCreation/>}/>
//         {/* MentorPortfolioTestList */}
//         <Route path='MentorPortfolioTestList' element={<MentorPortfolioTestList/>}/>

//         <Route path='Mock-interview-details' element={<MockInterviewDetails/>}/>
//         <Route path='Portfolio-test-details' element={<PortfolioTestDetails/>}/>
//         {/* Mentor_Interview_creation
//         MentorInterviewList */}
        

//         {/* Student  */}
//         {/* <Route path='student-courses'element={<Student_courses/>} /> */}
//         <Route path='student-courses' element={<Student_course_content/>}/>
//         <Route path='student-courses/player' element={<Student_course_content_player/>}/>
//         <Route path='student-courses/recordedLink' element={<Recorded_link_content_player/>}/>
//         <Route path='student-courses/liveClassRecording' element={<LiveClassRecording_content_player/>}/>
//         <Route path='student-test' element={<Student_test/> } />
//         <Route path='student-update-profile' element={<Student_Update_Profile/>}/>
//         <Route path='certification' element={<Certification/>}/>
//         <Route path='student-meetings' element={<Student_Meetings/>}/>
//         <Route path='Students-placements' element={<Students_placements/>}/>
//         <Route path='Self-learning-courses' element={<Self_learning_courses/>}/>
//         <Route path='Student_Assignment' element={<Student_Assignment/>}/>
//         <Route path='Student-change-password' element={<Student_change_password/>}/>
//         <Route path='student-test-details/:id' element={<Student_test_details/>}/>
//         <Route path="video-Show" element={<VideoShowPageTesting/>}/>

//           {/* Feedback form  */}
         

//           {/*  */}

//         <Route path='demopage' element={<DemoPAge/>}/>


//         {/* for the student video show page */}
//         <Route path='VideoShowPAge' element={<VideoShowPage/>}/>


        
//         {/*  route for error page */}
//         <Route path='*' element={<PageNotFound/>}/>
        
        
        
        
//        {/* Placement  */}
//         <Route path='Placement_Selected' element={<Selected/>}/>
//         {/* feedback */}
//         <Route path="feedback" element={<MeeingFeedbackForm/>}/>
//         {/* job lists */}
//         <Route path="jobLists" element={<JobListNew/>}/>
//       </Route>
//     ),
//     // {basename}
//   );

//   return <RouterProvider router={router} />;
// };

// export default Router;































































import React, { useContext, useState, useEffect, Suspense, lazy } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import { Datacontext } from './Context';
import './assets/css/Student_list/student_list.css';
import './assets/css/needed_css_rsuite.css';


// function importAllCss(r) {
//   r.keys().forEach(r);
// }
// importAllCss(require.context('./assets/css', true, /\.css$/));



// Lazy-load components
const App = lazy(() => import('./App'));
// Admin pages 
const Overview = lazy(() => import('./pages/Overview'));
const Login = lazy(() => import('./pages/Login'));
const Test = lazy(() => import('./pages/Test'));
const Student_List = lazy(() => import('./pages/Student_List'));
const Meeting = lazy(() => import('./pages/Meeting'));
const Courses = lazy(() => import('./pages/Courses'));
const Mentors = lazy(() => import('./pages/Mentors'));
const Batches = lazy(() => import('./pages/Batches'));
const Mentor_Students_Dashboard = lazy(() => import('./pages/Mentor_Students_Dashboard'));
const Admin_Change_password = lazy(() => import('./pages/Admin_Change_password'));
const Placements = lazy(() => import('./pages/Placements'));
const Settings = lazy(() => import('./pages/Settings'));
const Admin_Placement_List = lazy(() => import('./pages/Admin_Placement_List.jsx'));
const LeaveManagement = lazy(() => import('./pages/LeaveManagement'));
const Placement_Dashboard = lazy(() => import('./pages/Placement_Dashboard.jsx'));
// Mentor Pages 
const Mentor_Overview = lazy(() => import('./Mentor_section/pages/Mentor_Overview'));
const Change_password = lazy(() => import('./Mentor_section/pages/Change_password.jsx'));
const Mentor_courses = lazy(() => import('./Mentor_section/pages/Mentor_courses'));
const Mentor_tests = lazy(() => import('./Mentor_section/pages/Mentor_tests.jsx'));
const UpdateProfile = lazy(() => import('./Mentor_section/pages/UpdateProfile'));
const Mentor_Evaluation_Status = lazy(() => import('./Mentor_section/pages/Mentor_Evaluation_Status.jsx'));
const Mentor_Take_test = lazy(() => import('./Mentor_section/pages/Mentor_Take_test.jsx'));
const Mentor_See_Results = lazy(() => import('./Mentor_section/pages/Mentor_See_Results.jsx'));
const ViewTests = lazy(() => import('./Mentor_section/pages/ViewTests.jsx'));
const ApplyLeave = lazy(() => import('./Mentor_section/pages/ApplyLeave'));
const Mentor_Meeting = lazy(() => import('./Mentor_section/pages/Mentor_Meeting.jsx'));
const Mentor_Assignments_creation = lazy(() => import('./Mentor_section/pages/Mentor_Assignments_creation.jsx'));
const Mentor_Assignment_View = lazy(() => import('./Mentor_section/pages/Mentor_Assignment_View.jsx'));
const MentorViewQuestions = lazy(() => import('./Mentor_section/pages/MentorViewQuestions.jsx'));
const Mentor_Assingment_Sub_List = lazy(() => import('./Mentor_section/pages/Mentor_Assingment_Sub_List.jsx'));
const Mentor_Change_Password = lazy(() => import('./Mentor_section/pages/Mentor_Change_Password.jsx'));
const Exam_Evaluation = lazy(() => import('./Mentor_section/pages/Exam_Evaluation.jsx'));
const Mentor_Leave_Management = lazy(() => import('./Mentor_section/pages/Mentor_Leave_Management.jsx'));
// Student Pages 
const Student_Overview = lazy(() => import('./Student_section/Pages/Student_Overview.jsx'));
const Student_courses = lazy(() => import('./Student_section/Pages/Student_courses.jsx'));
const Student_course_content = lazy(() => import('./Student_section/Pages/Student_course_content.jsx'));
const Student_course_content_player = lazy(() => import('./Student_section/Pages/Student_course_content_player.jsx'));
const Student_test = lazy(() => import('./Student_section/Pages/Student_test.jsx'));
const Student_Update_Profile = lazy(() => import('./Student_section/Pages/Student_Update_Profile.jsx'));
const Certification = lazy(() => import("./Student_section/Pages/Certification.jsx"));
const Student_Meetings = lazy(() => import('./Student_section/Pages/Student_Meetings.jsx'));
const Students_placements = lazy(() => import("../src/Student_section/Pages/Students_Placements.jsx"));
const Self_learning_courses = lazy(() => import('./Student_section/Pages/Student_Self_Learning_Courses/LandingPage.jsx'));
const Student_Assignment = lazy(() => import("../src/Student_section/Pages/Student_Assignment.jsx"));
const Student_change_password = lazy(() => import('./Student_section/Pages/Student_change_password.jsx'));
const Student_test_details = lazy(() => import('./Student_section/Pages/Student_test_details.jsx'));
// Placement Pages 
const Placement_Drives = lazy(() => import('./Placement_section/Pages/Placement_Droves.jsx'));
const Placement_Selected = lazy(() => import('./Placement_section/Pages/Placement_Selected.jsx'));
const Applied = lazy(() => import('./Placement_section/Pages/Applied.jsx'));
const Selected = lazy(() => import('./Placement_section/Pages/Selected.jsx'));
const JobListNew = lazy(() => import('./Placement_section/Pages/NewJobList.jsx'));
// Other 
const PageNotFound = lazy(() => import('./ErrorPage/PageNotFound'));
const VideoShowPage = lazy(() => import('./Student_section/Components/ForTheCoursePart/VideoShowPage.jsx'));
const Maintenance = lazy(() => import('./pages/Maintenance.jsx'));
const DemoPAge = lazy(() => import('./Student_section/Pages/DemoPAge.jsx'));
const VideoShowPageTesting = lazy(() => import('./Student_section/Components/VideoPage/VideoShowPageTesting.jsx'));
const MeeingFeedbackForm = lazy(() => import('./utilities/MeeingFeedbackForm.jsx'));
const Upload_GETStudent_Feedback_download = lazy(() => import('./pages/Upload_GETStudent_Feedback_download.jsx'));
const JobList = lazy(() => import('./Placement_section/Pages/JobList.jsx'));
const JobDetails = lazy(() => import('./pages/JobDetails.jsx'));
const Mentor_Interview_creation = lazy(() => import('./Mentor_section/pages/Mentor_Interview_creation.jsx'));
const MentorInterviewList = lazy(() => import('./Mentor_section/pages/MentorInterviewList.jsx'));
const MentorPortfolioTestCreation = lazy(() => import('./Mentor_section/pages/MentorPortfolioTestCreation.jsx'));
const MentorPortfolioTestList = lazy(() => import('./Mentor_section/pages/MentorPortfolioTestList.jsx'));
const MockInterviewDetails = lazy(() => import('./Student_section/Pages/MockInterviewDetails.jsx'));
const PortfolioDetails = lazy(() => import('./Student_section/Components/Portfolio/PortfolioDetails.jsx'));
const PortfolioTestDetails = lazy(() => import('./Student_section/Pages/PortfolioTestDetails.jsx'));
const Recorded_link_content_player = lazy(() => import('./Student_section/Pages/Recorded_link_content_player.jsx'));
const LiveClassRecording_content_player = lazy(() => import('./Student_section/Pages/LiveClassRecording_content_player.jsx'));

const Router = () => {
  const { Usertype } = useContext(Datacontext);
  const [usertype, setUsertype] = useState(localStorage.getItem('userType'));

  useEffect(() => {
    if (Usertype) {
      setUsertype(Usertype);
      localStorage.setItem('userType', Usertype);
    }
  }, [Usertype]);

  const defaultRoute =
    usertype === 'Admin' ? (
      <Route index element={<Overview />} />
    ) : usertype === 'Mentor' || usertype=="Mentor_Assistant" ? (
      <Route index element={<Mentor_Overview />} />
    )
    : usertype === 'Student' ? (
      <Route index element={<Student_Overview />} />
    )
    : usertype === 'Placement' ? (
      <Route index element={<Applied/>} />
    )
    : (
      <Route index element={<Login />} />
    );

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path='/' element={<App />}>
        {defaultRoute}
        <Route path='test' element={<Test />} />
        <Route path='Student-List' element={<Student_List />} />
        <Route path='meeting' element={<Meeting />} />
        <Route path='change-password' element={<Change_password />} />
        <Route path='mentor-courses' element={<Mentor_courses />} />
        <Route path='mentors' element={<Mentors />}/>
        <Route path='courses' element={<Courses/>}/>
        <Route path='batches' element={<Batches/>}/>
        <Route path='mentor-test' element={<Mentor_tests/>}/>
        <Route path='member-profile' element={<UpdateProfile/>}/>
        <Route path='admin-change-password' element ={<Admin_Change_password/>}/>
        <Route path='placements' element={<Placements/>}/>
        <Route path='settings' element={<Settings/>}/>
        <Route path='mentor-apply-leave' element={<ApplyLeave/>}/>
        <Route path='mentor-meeting' element={<Mentor_Meeting/>}/>
        <Route path='testing' element={<h1>Bapan</h1>}/>
        <Route path='leave-management' element={<LeaveManagement />}/>
        <Route path='admin-placement-list' element={<Admin_Placement_List/>}/>
        <Route path='placement-dashboard' element={<Placement_Dashboard/>}/>
        <Route path="/maintenance" element={<Maintenance/>} />
        <Route path='feedback_upload_delete' element={<Upload_GETStudent_Feedback_download/> }/>
        <Route path='job-details' element={<JobDetails/> }/>

        {/* Mentor  */}
        <Route path='mentor-evaluation-status' element={<Mentor_Evaluation_Status/>} />
        <Route path='mentor-take-test' element={<Mentor_Take_test/>} />
        <Route path='mentor-see-results' element={<Mentor_See_Results/>} />
        <Route path='view-test' element={<ViewTests/>}/>
        <Route path='mentor-students-dashboard' element={<Mentor_Students_Dashboard/>}/>
        <Route path='mentor-assignments-creation' element={<Mentor_Assignments_creation/>}/>
        <Route path='Mentor-Assignment-View' element={<Mentor_Assignment_View/>}/>
        <Route path='Mentor-view-questions/:id' element={<MentorViewQuestions/>}/>
        <Route path='Mentor-Submission-List' element={<Mentor_Assingment_Sub_List/>}/>
        <Route path='Mentor-change-password' element={<Mentor_Change_Password/>}/>
        <Route path='test_evaluation' element={<Exam_Evaluation/>}/>
        <Route path='Mentor-Leave-Management' element={<Mentor_Leave_Management/>}/>
        <Route path='Mock-Interview-Creation' element={<Mentor_Interview_creation/>}/>
        <Route path='Mock-Interview-ALL' element={<MentorInterviewList/>}/>
        <Route path='Mentor-portfolio-test-creation' element={<MentorPortfolioTestCreation/>}/>
        <Route path='MentorPortfolioTestList' element={<MentorPortfolioTestList/>}/>
        <Route path='Mock-interview-details' element={<MockInterviewDetails/>}/>
        <Route path='Portfolio-test-details' element={<PortfolioTestDetails/>}/>

        {/* Student  */}
        <Route path='student-courses' element={<Student_course_content/>}/>
        <Route path='student-courses/player' element={<Student_course_content_player/>}/>
        <Route path='student-courses/recordedLink' element={<Recorded_link_content_player/>}/>
        <Route path='student-courses/liveClassRecording' element={<LiveClassRecording_content_player/>}/>
        <Route path='student-test' element={<Student_test/> } />
        <Route path='student-update-profile' element={<Student_Update_Profile/>}/>
        <Route path='certification' element={<Certification/>}/>
        <Route path='student-meetings' element={<Student_Meetings/>}/>
        <Route path='Students-placements' element={<Students_placements/>}/>
        <Route path='Self-learning-courses' element={<Self_learning_courses/>}/>
        <Route path='Student_Assignment' element={<Student_Assignment/>}/>
        <Route path='Student-change-password' element={<Student_change_password/>}/>
        <Route path='student-test-details/:id' element={<Student_test_details/>}/>
        <Route path="video-Show" element={<VideoShowPageTesting/>}/>

        <Route path='demopage' element={<DemoPAge/>}/>
        <Route path='VideoShowPAge' element={<VideoShowPage/>}/>

        {/* route for error page */}
        <Route path='*' element={<PageNotFound/>}/>

        {/* Placement  */}
        <Route path='Placement_Selected' element={<Selected/>}/>
        <Route path="feedback" element={<MeeingFeedbackForm/>}/>
        <Route path="jobLists" element={<JobListNew/>}/>
      </Route>
    ),
  );

  return (
    <Suspense >
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default Router;
